module.exports = __webpack_public_path__ + "static/media/close-button.37130647.svg";